export default "__VITE_ASSET__CbX4$Vw$__"